import { Injectable } from '@angular/core';
import { ServerConfigService } from '@app/configuration/server-config.service';
import { UserDto } from '@features/auth/user.dto';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ErrorMetrics } from './error-metrics';
import { EventMetrics } from './event-metrics';

@Injectable()
export class ApplicationInsightsService {
  private application: ApplicationInsights;

  constructor(configService: ServerConfigService) {
    this.application = new ApplicationInsights({
      config: {
        instrumentationKey:
          configService.config.applicationInsightsInstrumentationKey,
        enableDebug: configService.config.applicationInsightsDebug,
        enableAutoRouteTracking: true,
      },
    });
    this.application.loadAppInsights();
  }

  public identifyUser(user: UserDto) {
    this.application.setAuthenticatedUserContext(user.sub);
  }

  trackError(metrics: ErrorMetrics) {
    this.application.trackException(metrics);
  }

  trackEvent(event: EventMetrics) {
    this.application.trackEvent(event);
  }
}
